import { Chart } from "chart.js";
import "chart.js/auto";

import "./dayjs-chart-adapter";

Chart.defaults.locale = "en-US";
